module.exports = __webpack_public_path__ + "solovis.fc8cfeed5eeb8b364bd6f45f71cfab0a.svg";